// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
    /* Скрываем элементы, которые не должны отображаться при печати */
    @page {
        margin: 0; /* Убираем отступы страницы */
    }

    body {
        margin: 0; /* Убираем отступы тела страницы */
        padding: 0;
    }
    .logo
    {
        display: none;
    }
    /* Скрываем адрес страницы и дату */
    header, footer, nav, .no-print {
        display: none !important; /* Скрываем указанные элементы */
    }

    /* Другие стили для таблицы и контента */
    .table-container {
        /* Ваши стили для контейнера таблицы */
    }

    h1
    {
        font-size: 24px;
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }

    table img 
    {
        max-width: 125px;
    }
    th, td {
        padding: 8px;
        text-align: left;
    }

    th {
        background-color: #f2f2f2;
    }

    h1
    {
        font-family: ff1;
        line-height: 1.113000;
        font-style: normal;
        font-weight: normal;
        width: 100%;
        text-align: left;
    }

    #print-content
    {
        padding: 30px;
    }




.table {
    margin: 20px auto;
    width: 80%;
    border-collapse: collapse;
}

table {
    width: 100%;
    border: 1px solid #ddd;
}

th, td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

th {
    background-color: #f2f2f2;
    color: #333;
}

tr:hover {
    background-color: #f1f1f1; /* Цвет фона при наведении на строку */
}

h2 {
    text-align: center;
    color: #333;
}
}`, "",{"version":3,"sources":["webpack://./src/pages/archive/PrintStyles.css"],"names":[],"mappings":"AAAA;IACI,iEAAiE;IACjE;QACI,SAAS,EAAE,6BAA6B;IAC5C;;IAEA;QACI,SAAS,EAAE,kCAAkC;QAC7C,UAAU;IACd;IACA;;QAEI,aAAa;IACjB;IACA,mCAAmC;IACnC;QACI,wBAAwB,EAAE,gCAAgC;IAC9D;;IAEA,wCAAwC;IACxC;QACI,sCAAsC;IAC1C;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;QAChB,qBAAqB;QACrB,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;QACX,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;IACjB;;;;;AAKJ;IACI,iBAAiB;IACjB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB,EAAE,sCAAsC;AACrE;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA","sourcesContent":["@media print {\n    /* Скрываем элементы, которые не должны отображаться при печати */\n    @page {\n        margin: 0; /* Убираем отступы страницы */\n    }\n\n    body {\n        margin: 0; /* Убираем отступы тела страницы */\n        padding: 0;\n    }\n    .logo\n    {\n        display: none;\n    }\n    /* Скрываем адрес страницы и дату */\n    header, footer, nav, .no-print {\n        display: none !important; /* Скрываем указанные элементы */\n    }\n\n    /* Другие стили для таблицы и контента */\n    .table-container {\n        /* Ваши стили для контейнера таблицы */\n    }\n\n    h1\n    {\n        font-size: 24px;\n    }\n\n    table {\n        width: 100%;\n        border-collapse: collapse;\n    }\n\n    table img \n    {\n        max-width: 125px;\n    }\n    th, td {\n        padding: 8px;\n        text-align: left;\n    }\n\n    th {\n        background-color: #f2f2f2;\n    }\n\n    h1\n    {\n        font-family: ff1;\n        line-height: 1.113000;\n        font-style: normal;\n        font-weight: normal;\n        width: 100%;\n        text-align: left;\n    }\n\n    #print-content\n    {\n        padding: 30px;\n    }\n\n\n\n\n.table {\n    margin: 20px auto;\n    width: 80%;\n    border-collapse: collapse;\n}\n\ntable {\n    width: 100%;\n    border: 1px solid #ddd;\n}\n\nth, td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n}\n\nth {\n    background-color: #f2f2f2;\n    color: #333;\n}\n\ntr:hover {\n    background-color: #f1f1f1; /* Цвет фона при наведении на строку */\n}\n\nh2 {\n    text-align: center;\n    color: #333;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
